export const BoilerPlateStatus = {
  Draft: "Draft", 
  Live: "Live",
  Inactive: "Inactive",
  };